module.exports = {"510703001":"城厢街道","510703002":"城北街道","510703003":"工区街道","510703004":"南山街道","510703005":"朝阳街道","510703006":"高新街道","510703007":"城南街道","510703008":"金家林街道","510703009":"科创园街道","510703100":"丰谷镇","510703101":"关帝镇","510703102":"塘汛镇","510703103":"青义镇","510703104":"龙门镇","510703105":"石塘镇","510703106":"吴家镇","510703107":"杨家镇","510703108":"金峰镇","510703109":"玉皇镇","510703110":"新皂镇","510703111":"河边镇","510703112":"磨家镇","510703113":"永兴镇","510703200":"城郊乡","510703201":"石洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510703.json
// module id = 2119
// module chunks = 0